<div>
  @if (loading) {
    <mat-progress-bar class='mt-24 mb-24' style='min-width:300px' mode="indeterminate"></mat-progress-bar>
  }

  <div class='mt-24'>
    @if (isAdmin) {
      <div>
        <p>{{'Ruolo di tipo amministrativo, accesso completo al pannello.' | translate}}</p>
      </div>
    }
    @if (!isAdmin) {
      <table class='px-16'>
        <thead>
          <tr>
            <th>Area</th>
            <th>Tipo accesso</th>
          </tr>
        </thead>
        <tbody>
          @for (permission of rolePermissions; track permission) {
            @if (permission.code !== 'domains_group') {
              <tr class='permission-row'>
                <td>
                  <span class='h5' [matTooltip]='permission.description'>{{permission.name}}</span>
                </td>
                <td>
                  <div>
                    @if (permission.access_level != null) {
                      <mat-form-field>
                        <mat-select [value]='permission.access_level' (valueChange)='changeAccessType(permission, $event)'>
                          <mat-option [value]='0'>{{'Accesso Vietato' | translate}}</mat-option>
                          <mat-option [value]='1'>{{'Può visualizzare' | translate}}</mat-option>
                          <mat-option [value]='2'>{{'Può aggiungere e modificare' | translate}}</mat-option>
                          <mat-option [value]='3'>{{'Accesso completo' | translate}}</mat-option>
                        </mat-select>
                        @if (changingGroupAccess[permission.id]) {
                          <mat-spinner diameter='20' matSuffix></mat-spinner>
                        }
                      </mat-form-field>
                    }
                    @for (action of permission.actions; track action) {
                      @if (!action.default_action) {
                        <mat-checkbox
                          [matTooltip]='action.description'
                          class="no-default-action"
                          (change)="changeState(permission, action, $event.checked)"
                          [checked]="action.active"
                          >
                          {{action.name}}
                        </mat-checkbox>
                      }
                    }
                  </div>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    }

  </div>
</div>